import React from "react";

import {uniqueId} from "lodash";
import Format from "../../utils/format";

const PreviewTableTranslate = ({tables}) => {
    return (
        <div className="accordion" id="accordionPT">
            { tables?.map((table, index) =>

                <div className="accordion-item mb-0" key={index}>
                    <h2 className="accordion-header" id={`heading-table-pt-${index}`}>
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target={`#table-pt-${index}`} aria-expanded="false" aria-controls={`table-pt${index}`}>
                            #{index} - <b className="ps-1">{ table.titulo }</b>
                        </button>
                    </h2>
                    <div id={`table-pt-${index}`} className="accordion-collapse collapse" aria-labelledby={`heading-table-pt-${index}`}
                         data-bs-parent="#accordionPT">
                        <div className="accordion-body p-0">

                            <div key={table.id} className="mb-4">

                                <div className="row m-0">
                                    <div className="col-12 border-bottom px-3 pt-3">
                                        <p className="fw-bolder">Titulo: {table?.titulo && <span className="fw-normal"> {table?.titulo}</span>}</p>
                                    </div>
                                </div>

                                <div className="table-responsive m-3">
                                    <table className="table table-bordered align-middle">
                                        <thead>
                                            { table.headers.map((head, index) =>
                                                <tr key={`head-${index}`}>
                                                    { head?.map((column, position) =>
                                                        <th className="text-center fw-bolder" key={position}>
                                                            {column.value}
                                                        </th>
                                                    )}
                                                </tr>
                                            )}
                                        </thead>

                                        <tbody>
                                        { table.rows.map((row, index) => (
                                            <tr key={`body-${index}`}>
                                                {row.map((item, position) =>
                                                    <td  key={uniqueId()}
                                                         className={`${position === 0 ? 'text-start' : 'text-end'} preview-data`}
                                                         style={{minWidth: "200px"}}>
                                                        <Format
                                                            value={item.value}
                                                            unit={item.unit}
                                                            editInputRow={() => {}}
                                                            rowPosition={() => {}}
                                                            position={position}
                                                            displayType={'text'}
                                                        />
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="px-3">
                                    <p className="fw-bolder mt-4">Rodapé:</p>
                                    <div className="table-footer mb-4">
                                        <div dangerouslySetInnerHTML={{__html: table.footer}}/>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            )}
        </div>
    )
}

export default PreviewTableTranslate
